<template>
  <form @submit.prevent="submit">
    <base-modal small target="investorRefinanceModal" title="Change Refinance">
      <template v-if="completed">
        <p class="text-center">
          Shares have successfully been refinanced.
        </p>
      </template>
      <template v-else-if="pending">
        <base-loader>Refinancing...</base-loader>
      </template>
      <template v-else>
        <base-field label="Investor">
          <base-select
            v-model="user"
            store="core.users.investors"
            store-action="core/users/investors"
            store-text="email"
            placeholder="investor"
            required />
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Amount">
          <base-input v-model="amount" numeric placeholder="amount" required />
        </base-field>
        <template v-if="user && investor">
          <div class="bg-light text-center">
            <strong>{{ totalValue }}</strong> total value.
          </div>
          <div class="bg-light text-center">
            <strong>{{ totalRefinanced }}</strong> currently refinanced.
          </div>
        </template>
      </template>
      <template v-if="!pending" v-slot:footer>
        <template v-if="completed">
          <base-button @click="close">Close</base-button>
        </template>
        <template v-else>
          <base-button @click="close">Cancel</base-button>
          <base-button secondary submit>Refinance</base-button>
        </template>
      </template>
    </base-modal>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import EventBus from '../libs/EventBus'

export default {
  name: 'InvestmentUnitRefinance',

  data: () => ({
    amount: '',
    completed: false,
    user: ''
  }),

  computed: {
    totalRefinanced () {
      return this.$formatting.toCurrency(this.investor.totalRefinanced)
    },

    totalValue () {
      return this.$formatting.toCurrency(this.investor.totalValue)
    },

    ...mapState({
      investment: store => store.core.investments.entity,
      investor: store => store.core.shares.investor,
      pending: store => store.core.shares.isRefinancePending
    })
  },

  methods: {
    close () {
      this.$modal.close('#investorRefinanceModal')

      this.amount = ''
      this.completed = false
      this.user = ''
    },

    submit () {
      this.refinance({
        amount: this.amount,
        investment: this.investment,
        user: this.user
      })
        .then(() => {
          this.completed = true

          EventBus.$emit('reload-PaginatedList-shares')
        })
        .catch(err => this.$flash.failure(err))
    },

    ...mapActions({
      getInvestorShareStatus: 'core/shares/investor',
      refinance: 'core/shares/refinance'
    })
  },

  watch: {
    user: {
      deep: true,
      handler () {
        if (this.user) {
          this.getInvestorShareStatus({
            investment: this.investment._id,
            user: this.user
          })
        }
      }
    }
  }
}
</script>
